import React from "react"
import { Link, useLocation } from "react-router-dom"
import { withTranslation } from "react-i18next"

const BottomNavigation = props => {
  const location = useLocation()
  const pathname = location.pathname

  const isActive = path => pathname === path || pathname.startsWith(path + "/")

  return (
    <nav className="mobile-bottom-nav d-md-none">
      <Link
        to="/dashboard"
        className={`mobile-bottom-nav__item ${isActive("/dashboard") ? "active" : ""}`}
      >
        <i className="bx bx-home-circle" />
        <span>{props.t("Home")}</span>
      </Link>

      <Link
        to="/branches"
        className={`mobile-bottom-nav__item ${isActive("/branches") ? "active" : ""}`}
      >
        <i className="bx bx-buildings" />
        <span>{props.t("Branches")}</span>
      </Link>

      <Link
        to="/menus/items"
        className={`mobile-bottom-nav__item ${isActive("/menus") ? "active" : ""}`}
      >
        <i className="bx bx-food-menu" />
        <span>{props.t("Menu")}</span>
      </Link>

      <Link
        to="/f&b-orders"
        className={`mobile-bottom-nav__item ${isActive("/f&b-orders") ? "active" : ""}`}
      >
        <i className="bx bx-receipt" />
        <span>{props.t("Orders")}</span>
      </Link>

      <button
        type="button"
        className="mobile-bottom-nav__item"
        onClick={() => {
          var body = document.body
          body.classList.toggle("sidebar-enable")
        }}
      >
        <i className="bx bx-menu" />
        <span>{props.t("More")}</span>
      </button>
    </nav>
  )
}

export default withTranslation()(BottomNavigation)
